import React, { useEffect, useState } from 'react';
import { getProgressStream } from '../services/api';
import { Progress } from './ui/progress';

function ProgressBar({ jobId, onComplete }) {
  const [progress, setProgress] = useState(0);
  const [phase, setPhase] = useState('Initializing');
  const [message, setMessage] = useState('');

  useEffect(() => {
    if (!jobId) return;

    const eventSource = getProgressStream(jobId);

    eventSource.onmessage = (event) => {
      try {
        const data = JSON.parse(event.data);
        
        if (data.error) {
          setMessage(`Error: ${data.error}`);
          eventSource.close();
          return;
        }

        setProgress(data.progress || 0);
        setPhase(data.phase || 'Processing');
        setMessage(data.message || '');

        if (data.progress >= 100) {
          eventSource.close();
          setTimeout(() => {
            if (onComplete) onComplete();
          }, 1000);
        }
      } catch (err) {
        console.error('Error parsing progress data:', err);
      }
    };

    eventSource.onerror = (err) => {
      console.error('SSE error:', err);
      eventSource.close();
      setMessage('Connection error. Please refresh the page.');
    };

    return () => {
      eventSource.close();
    };
  }, [jobId, onComplete]);

  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <span className="text-sm font-medium text-foreground">{phase}</span>
        <span className="text-sm font-bold text-emerald-600">{progress}%</span>
      </div>
      
      <Progress value={progress} className="h-3" />
      
      {message && (
        <p className="text-sm text-muted-foreground text-center animate-pulse">
          {message}
        </p>
      )}
    </div>
  );
}

export default ProgressBar;
